import { render } from "./DoodleBackground.vue?vue&type=template&id=56a9e94c"
import script from "./DoodleBackground.vue?vue&type=script&lang=js"
export * from "./DoodleBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__